import { DashboardHeader } from "@/components/non_registrant/dashboard-header";
import { QuickBooksWeeklyRevenue } from "@/components/non_registrant/quickbooks-weekly-revenue";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/operator/quickbooks")({
  component: OperatorQuickBooksPage,
});

function OperatorQuickBooksPage() {
  return (
    <div className="flex min-h-0 w-full flex-1 flex-col gap-8 overflow-y-auto">
      <DashboardHeader
        title="Revenue Audit"
        subtitle="Compare live Hera collections, cash timing, and the QuickBooks trust ledger"
      />
      <QuickBooksWeeklyRevenue />
    </div>
  );
}
